export default __webpack_public_path__ + "static/founders-grotesk-regular-df2e137eb889965ace8669d8cf649df9.woff";